import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import ButtonGroup from '../Components/ButtonGroup';
import Colors from '../Styles/Colors';
import Fonts from '../Styles/Fonts';

const StyledButton = styled(Link)`
    ${Fonts.spectral.semibold};
    background-color: ${Colors.goldDark};
    border-bottom: 3px solid ${Colors.goldLight};
    color: ${Colors.black};
    font-size: 17px;
    line-height: 17px;    
    text-decoration: none;
    padding: 20px 25px 15px;
    text-align: center;

    ${ButtonGroup} & {
        margin-bottom: 9px;
    }
`;

const StyledLink = styled.a`
    ${Fonts.spectral.semibold};
    background-color: ${Colors.goldDark};
    border-bottom: 3px solid ${Colors.goldLight};
    color: ${Colors.black};
    font-size: 17px;
    line-height: 17px;    
    text-decoration: none;
    padding: 20px 25px 15px;
    text-align: center;

    ${ButtonGroup} & {
        margin-bottom: 9px;
    }
`;

const StyledFormButton = styled.button`
    ${Fonts.spectral.semibold};
    background-color: ${Colors.goldDark};
    border-bottom: 3px solid ${Colors.goldLight};
    color: ${Colors.black};
    font-size: 17px;
    line-height: 17px;    
    text-decoration: none;
    padding: 20px 25px 15px;
    text-align: center;
    
`;

class Button extends Component {
  componentDidMount = () => {
  };

  render() {
    if (this.props.type) {
      return <StyledFormButton {...this.props}>{ this.props.children }</StyledFormButton>
    } else if (this.props.href) {
      return (
        <StyledLink href={this.props.href} target={this.props.target} onClick={this.props.onClick}>{this.props.children}</StyledLink>
      );
    } else {
      return (
        <StyledButton to={this.props.to} target={this.props.target} onClick={this.props.onClick}>{this.props.children}</StyledButton>
      );
    }
  }
}

export default Button;
